import React from "react";
import { motion } from "framer-motion";
import story from "../Images/story.png";

const OurStory = () => {
  return (
    <section className="flex flex-col lg:flex-row items-center justify-between px-6 md:px-12 lg:px-20 py-12 md:py-16 lg:py-24 overflow-hidden">
      
      {/* Left Side: Animated Text */}
      <motion.div
        className="w-full lg:w-1/2 text-center lg:text-left"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
                <motion.button
                  className="relative bg-[#432DD7] text-[20px] font-[Nunito] text-white p-4 w-[185px] rounded-full"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  About Us
                </motion.button>

        <h2 className=" relative text-2xl md:text-4xl lg:text-4xl font-bold text-gray-900 leading-snug" style={{fontFamily:"PT Sans"}}>
          Client success is our priority
        </h2>
        
        <p style={{ fontFamily: "Allison, sans-serif" }} className="relative text-purple-600 text-4xl md:text-5xl italic mt-2">
          and innovation is our fuel.
        </p>

        <p className="relative text-[#62739E] mt-4 leading-relaxed text-[16px] ">
          Founded in 2016, Godhani Technology began with a simple mission: to help businesses leverage technology to achieve their goals. What started as a small team of passionate developers has grown into a full-service IT solutions provider with a global client base.
        </p>

        <p className="relative text-[#62739E] mt-4 leading-relaxed text-[16px]">
          Over the years, we've evolved our services to meet the changing needs of businesses in the digital age. From web development to artificial intelligence, we've stayed at the forefront of technology to deliver cutting-edge solutions that drive innovation and growth.
        </p>

        <p className="relative text-[#62739E] mt-4 leading-relaxed text-[16px]">
          Today, we're proud to be a trusted partner for businesses of all sizes, from startups to enterprises. Our team of experts is dedicated to delivering exceptional results and providing the technological edge that businesses need to succeed in today's competitive landscape.
        </p>
      </motion.div>

      {/* Right Side: Animated Image */}
      <motion.div
        className="relative w-full lg:w-1/2 mt-8 lg:mt-0 flex justify-center"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <img
          src={story}
          alt="Team Discussion"
          className="rounded-lg shadow-lg w-full max-w-[90%] md:max-w-[80%] lg:max-w-[75%] object-cover"
        />
      </motion.div>
      
    </section>
  );
};

export default OurStory;